import React, { useEffect, useState } from "react";
import "../../styles/Banner.scss";

interface BannerItem {
  id: number;
  type: string;
  url: string;
}

const Banner: React.FC = () => {
  const [banners, setBanners] = useState<BannerItem[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    fetch("/banner.json")
      .then((res) => res.json())
      .then((data) => setBanners(data));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % banners.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [banners]);

  return (
    <div className="banner-container">
      {banners.map((item, index) => (
        <img
          key={item.id}
          src={item.url}
          className={`banner-image ${index === activeIndex ? "active" : ""}`}
          alt={`Banner ${index + 1}`}
        />
      ))}
      <div className="dots">
        {banners.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === activeIndex ? "active" : ""}`}
            onClick={() => setActiveIndex(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default Banner;
